export default __webpack_public_path__ + "static/media/paying-it-logo_groot.4f868e9f.png";